import { useEffect, useState } from "react";
import EquipmentTable from "./EquipmentTable";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import MobileUnitApi from "../../../../api/MobileUnitApi";
import Cookies from "js-cookie";

export default function EditTab({ refreshEquipment }) {
    const portalToken = Cookies.get("portalSession");

    const { selectedMobileUnit } = useSelector((state) => state.equipmentsPortfolio);

    const [equipmentVals, setEquipmentVals] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [otp, setOtp] = useState("");
    const [verifyToken, setVerifyToken] = useState("");

    const [alert, setAlert] = useState({
        color: "primary",
        text: "",
        show: false,
    });

    const [disableModal, setDisableModal] = useState(false);

    // Update Equipment Vals on selected mobile unit change
    useEffect(() => {
        if (!selectedMobileUnit) {
            clearEqVals();
            setAlert({
                color: "primary",
                text: "Select a Mobile Unit to Get Started",
                show: true,
            });
            return;
        }
        if (selectedMobileUnit.location_node_id == null) {
            clearEqVals();
            setAlert({
                color: "primary",
                text: "Can Only Edit Active Locations. Create a New Location to Activate.",
                show: true,
            });
            return;
        }
        setEquipmentVals({
            equipmentName: selectedMobileUnit.location_name,
            voltage: selectedMobileUnit.np_voltage,
            current: selectedMobileUnit.np_current,
            sf: selectedMobileUnit.np_sf,
            freq: selectedMobileUnit.np_frequency,
            rpm: selectedMobileUnit.np_rpm,
            hp: selectedMobileUnit.np_hp,
            poles: selectedMobileUnit.poles,
            rotorBars: selectedMobileUnit.rotorBars,
            _equipmentType: selectedMobileUnit.equipment_type,
            _starter: selectedMobileUnit.starter,
            _vTapLocation: selectedMobileUnit.v_tap_location,
            _CTLocation: selectedMobileUnit.ct_location,
        });
    }, [selectedMobileUnit]);

    const clearEqVals = () => {
        setEquipmentVals({
            equipmentName: "",
            voltage: "",
            current: "",
            sf: "",
            freq: "",
            rpm: "",
            hp: "",
            poles: "",
            rotorBars: "",
            equipmentType: null,
            starter: null,
            vTapLocation: null,
            CTLocation: null,
        });
    };

    const onSubmit = () => {
        // setDisableModal(false);
        // setShowModal(true);
        // setOtp("");

        MobileUnitApi.editLocation(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            selectedMobileUnit.location_id,
            selectedMobileUnit.node_sn,
            equipmentVals?.equipmentName,
            equipmentVals?.voltage,
            equipmentVals?.current,
            equipmentVals?.sf,
            equipmentVals?.freq,
            equipmentVals?.rpm,
            equipmentVals?.hp,
            equipmentVals?.poles,
            equipmentVals?.rotorBars,
            equipmentVals?.equipmentType?.value,
            equipmentVals?.starter?.value,
            equipmentVals?.vTapLocation?.value,
            equipmentVals?.CTLocation?.value,
        )
            .then((resp) => {
                // if (resp.status == 200 && resp.data.data?.token) {
                //     setVerifyToken(resp.data.data.token);
                // }
                if (resp.status == 200) {
                    setAlert({
                        color: "success",
                        text: "Edit Successful. Analytics Will Update In a Few Minutes.",
                        show: true,
                    });
                    refreshEquipment();
                } else {
                    const text = resp.data.errorMessage ?? "Error Updating Location. Please Try Again Later.";
                    setAlert({
                        color: "danger",
                        text: text,
                        show: true,
                    });
                    // setShowModal(false);
                }
            })
            .catch((err) => {
                const text = err.response?.data?.errorMessage ?? "Error Updating Location. Please Try Again Later.";
                setAlert({
                    color: "danger",
                    text: text,
                    show: true,
                });
                // setShowModal(false);
            });
    };

    const onConfirm = () => {
        setDisableModal(true);
        MobileUnitApi.confirmEdit(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            selectedMobileUnit.location_id,
            verifyToken,
            otp,
        )
            .then((resp) => {
                if (resp.status == 200) {
                    setAlert({
                        color: "success",
                        text: "Edit Successful. Analytics Will Update In a Few Minutes.",
                        show: true,
                    });
                } else {
                    setAlert({
                        color: "danger",
                        text: "Error Updating Location. Please Try Again Later.",
                        show: true,
                    });
                }
                setShowModal(false);
                setOtp("");
                setVerifyToken("");
                setDisableModal(false);
            })
            .catch((err) => {
                const text = err.response?.data?.errorMessage ?? "Error Updating Location. Please Try Again Later.";
                setAlert({
                    color: "danger",
                    text: text,
                    show: true,
                });
                setShowModal(false);
                setOtp("");
                setVerifyToken("");
                setDisableModal(false);
            });
    };

    const onCancel = () => {
        setShowModal(false);
        setOtp("");
        setVerifyToken("");
    };

    const isOtpValid = (val) => {
        const re = /[^0-9]/;
        if (re.test(val)) return false;
        if (val.length > 8) return false;
        return true;
    };

    const onOtpUpdate = (event) => {
        const val = event.target.value;
        const valid = isOtpValid(val);
        if (valid) {
            setOtp(val);
        }
        return;
    };

    const isActiveLocation = selectedMobileUnit?.location_node_id != null;

    const isDisabled = (selectedMobileUnit == null || !isActiveLocation) ?? true;

    return (
        <div>
            <br />
            <Col>
                <Alert
                    variant={alert.color}
                    show={alert.show}
                    dismissible
                    onClose={() => setAlert({ color: "", text: "", show: false })}
                >
                    {alert.text}
                </Alert>
            </Col>
            <EquipmentTable props={equipmentVals} setProps={setEquipmentVals} disabled={isDisabled}></EquipmentTable>
            <Col>
                <Button onClick={onSubmit} disabled={isDisabled}>
                    Submit
                </Button>
            </Col>
            <Modal show={showModal} size="lg" centered onHide={onCancel}>
                <Modal.Header>
                    <h4>Confirm Location Update</h4>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control
                        value={otp}
                        onChange={(e) => onOtpUpdate(e)}
                        // type="number"
                        // disabled={disabled}
                        // isInvalid={!isDurationValid(duration)}
                        placeholder="OTP Code. Ex: 12345678"
                        disabled={disableModal}
                    />
                    A One Time Password Has Been Sent To Your Email.
                    <br />
                    The Location Settings & Ratings Will Be Updated Shortly After Confirmation.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel} disabled={disableModal}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} disabled={disableModal}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
